import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../config/Firebase"; // Asegúrate de que la ruta a tu config de Firebase sea correcta

// 1. Crear el Contexto
const FilterContext = createContext();

// 2. Hook personalizado para usar el contexto fácilmente
export const useFilter = () => {
  return useContext(FilterContext);
};

// 3. Crear el Proveedor del Contexto
export const FilterProvider = ({ children }) => {
  const [bannedWords, setBannedWords] = useState([]);
  const [loading, setLoading] = useState(true);

  // Función para normalizar texto: quitar tildes y reemplazar números por letras
  const normalizeText = (text) => {
    if (!text) return "";
    return text
      .normalize("NFD") // Descompone los caracteres acentuados en letra + tilde
      .replace(/[\u0300-\u036f]/g, "") // Elimina los diacríticos (tildes)
      .replace(/1/g, "i")
      .replace(/3/g, "e")
      .replace(/4/g, "a")
      .replace(/5/g, "s")
      .replace(/7/g, "t")
      .replace(/0/g, "o");
  };

  // Cargar las palabras prohibidas desde Firestore al iniciar
  useEffect(() => {
    const fetchBannedWords = async () => {
      try {
        const docRef = doc(db, "configuracion", "filtros");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          // Nos aseguramos de que el campo exista y sea un array
          if (
            data.palabras_prohibidas &&
            Array.isArray(data.palabras_prohibidas)
          ) {
            // Normaliza las palabras prohibidas al cargarlas
            const normalizedBannedWords = data.palabras_prohibidas.map((word) =>
              normalizeText(word.toLowerCase()),
            );
            setBannedWords(normalizedBannedWords);
          }
        }
      } catch (error) {
        console.error("Error al cargar las palabras prohibidas:", error);
        // Opcional: manejar el error, quizás reintentar o mostrar un aviso
      } finally {
        setLoading(false);
      }
    };

    fetchBannedWords();
  }, []);

  // Función de validación que se compartirá a través del contexto
  const validateText = useCallback(
    (text) => {
      if (!text || bannedWords.length === 0) {
        return { isValid: true, foundWord: null };
      }

      const normalizedInput = normalizeText(text.toLowerCase());

      const foundWord = bannedWords.find((bannedWord) => {
        const escapedBannedWord = bannedWord.replace(/[.*+?^${}()|[\]\\]/g); // Escape special characters
        const regex = new RegExp(`\\b${escapedBannedWord}\\b`, "i"); // 'i' for case-insensitive, though input is already lowercased
        return regex.test(normalizedInput);
      });

      return {
        isValid: !foundWord,
        foundWord: foundWord || null, // Devuelve la palabra original prohibida si se encuentra
      };
    },
    [bannedWords],
  );

  const value = {
    validateText,
    isFilterLoading: loading,
  };

  return (
    <FilterContext.Provider value={value}>{children}</FilterContext.Provider>
  );
};
